import React, { Component } from 'react';
import { graphql } from 'react-apollo';
import { gql } from 'apollo-boost';
import { Row, Col } from 'react-bootstrap';
import { Typography, Button, TextField } from '@material-ui/core';
import { withRouter } from 'react-router';

import Logo from '../../../images/logo.png';


class CreateAcc extends Component {
    constructor() {
        super();
        this.state = {
            email: '',
            errorMessage: '',
            to: '/registration',
            from: '/createAccount',
        }
    }
    render() {
        const handleChangeEmail = prop => event => {
            this.setState({ ...this.state, [prop]: event.target.value });
        };
        const ValidateEmail = (mail) => {
            if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail)) {
                this.setState({ ...this.state, errorMessage: '' });
                return (true)
            }
            this.setState({ ...this.state, errorMessage: 'You have entered an invalid email address!' });
            return (false)
        }
        return (
            <div className="container-custom pt-10">
                <form
                    onSubmit={e => {
                        e.preventDefault();
                        if (ValidateEmail(this.state.email)) {
                            this.props.mutate({
                                variables: {
                                    email: this.state.email,
                                }
                            }).then((res) => {
                                if (res.data.sendPinCodeForRegister.Status.code === 200) {
                                    this.props.history.push({
                                        pathname: '/emailConfirmation',
                                        state: {
                                            email: this.state.email,
                                            to: this.state.to,
                                            from: this.state.from
                                        }
                                    });
                                    this.setState({ ...this.state, errorMessage: res.data.sendPinCodeForRegister.Status.message });
                                }
                                else {
                                    this.setState({ ...this.state, errorMessage: res.data.sendPinCodeForRegister.Status.message });
                                }
                            }).catch((err) => this.setState({ ...this.state, errorMessage: "Check your internet connection" }))
                        }
                    }
                    }
                    className="container" autoComplete="off">
                    <div className="pt-1 pb-3">
                        <img src={Logo} alt="spreago logo" width="150px" />
                    </div>
                    <div className="pb-3">
                        <Typography variant="h4" color="primary" >Create Account</Typography>
                    </div>
                    <div className="pt-1 pb-3">
                        <Typography variant="subtitle1" className="text-dark">Please enter your email address and you will receive the confirmation code to continue your registeration</Typography>
                    </div>
                    <div className="pt-4">
                        <TextField
                            required
                            fullWidth
                            type="email"
                            label="Email"
                            color="primary"
                            variant="outlined"
                            value={this.state.email}
                            onChange={handleChangeEmail('email')}
                        />
                    </div>
                    <Row className="pt-3">
                        <Col xs={12}>
                            <div className="text-danger"><p>{this.state.errorMessage}</p></div>
                        </Col>
                        <Col xs={6} className="text-right">
                            <Button type="submit" size="large" className="btn-orange-gradiant pr-5  w-100 pl-5" variant="contained" color="primary">Continue</Button>
                        </Col>
                        <Col xs={6} className="text-left">
                            <Button
                                size="large"
                                className="btn-white-gradiant pr-5 pl-5  w-100"
                                onClick={e => {
                                    this.props.history.push({
                                        pathname: '/'
                                    })
                                }}>Login
                                </Button>
                        </Col>
                    </Row>

                </form>
            </div>
        );
    }
}
const SEND_CODE = gql`
mutation( $email : Email! ){
    sendPinCodeForRegister(email: $email){
      Status{
        code
        message
      }
    }
  }
`;


export default graphql(SEND_CODE)(withRouter(CreateAcc))